<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<app-breadcrumb></app-breadcrumb>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="menu-container">
  <div class="row menu-row-container">
    <div class="col-sm-6 gridName-container" style="margin-bottom: 5px;">
      <span class="gridName">Register</span>
    </div>
  </div>
</div>
<div class="table-container">
  <div id="header-container" class="row" style="height: auto;">
    <div class="col-md-1">

    </div>
    <div class="col-md-6">
      <div class="row">
        <div class="col-md-4"><label>Target Organization Name</label></div>
        <div class="col-md-8">
          <input type="text" class="input-filed-continers uppercase" [(ngModel)]="targetShortName">
        </div>
      </div>
      <br>
      <div class="row">
        <div class="button-continer" mat-dialog-actions class="btn-align" style="display: block;">
          <button mat-stroked-button class="addButton" (click)="registerOrgFunc()">
            <i class="fa fa-save"></i> Register
          </button>
          <br>
          <a style="cursor: pointer;text-decoration: underline;color: blue;" (click)="viewOrgsFunc()">View Registered
            Organization</a>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #confirmationPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="okForConfirmation()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <!-- <h2 mat-dialog-title class="close-button">ONE-<span style="color:gold;">QMS</span></h2> -->

    <div mat-dialog-title>
      <label class="popupTitle">Confirmation</label>
      <label class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 10px;">
      <div>
        <div class="row">
          <div class="col-md-12 text-center">
            <pre *ngIf="resultType =='S'"
              style="color: green;font-size: inherit;font-family: inherit;">{{resultMsg}}</pre>
            <pre *ngIf="resultType =='E'"
              style="color: red;font-size: inherit;font-family: inherit;">{{resultMsg}}</pre>
          </div>

        </div>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="addButton" (click)="okForConfirmation()">
        OK
      </button>
    </div>
  </div>
</ng-template>
<ng-template #viewOrgspopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="viewOrgConfirmation()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <!-- <h2 mat-dialog-title class="close-button">ONE-<span style="color:gold;">QMS</span></h2> -->

    <div mat-dialog-title>
      <label class="popupTitle">Organizations</label>
      <label class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 10px;">
      <div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-container">
              <div id="header-container" class="row">
                <div class="col-md-4">
                  <div class="row-search-container">

                    <input type="text" class="form-control" style="font-size: 13px;" placeholder="Search"
                      [(ngModel)]="searchValue1">
                  </div>
                </div>
                <div class="col-8 col-md-6pr-0 d-flex  justify-content-end align-items-center">

                  {{ showingRowsText }}
                  1-{{ perPage }} of {{ collectionSize | number }}
                  <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)"
                    [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                    [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true"
                    size="sm">
                  </ngb-pagination>
                  <div ngbDropdown class="d-inline-block leftpadding">
                    <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic1" ngbDropdownToggle>
                      {{perPage}}
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                      <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
                      <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
                    </div>
                    per page
                  </div>
                </div>
              </div>
              <table class="dynamic-table-container">
                <th style="min-width: 80px;max-width: 80px;"> <span>Org ID</span> <span
                    class="fa-solid fa-filter"></span> </th>
                <th> <span>Org Name</span> <span class="fa-solid fa-filter"></span> </th>
                <th> <span>Registered On</span> <span class="fa-solid fa-filter"></span> </th>
                <th> <span> Created On</span> <span class="fa-solid fa-filter"></span> </th>
                <th> <span>Status</span> <span class="fa-solid fa-filter"></span> </th>
                <th> <span>Comments</span> <span class="fa-solid fa-filter"></span> </th>
                <th id="menu" class="sticky-col first-col"></th>
                <tr class="data-row-container"
                  *ngFor="let org of pagedItems1 | searchFilter : searchValue1; let idx = index;">
                  <td class="row-data" style="min-width: 80px;max-width: 80px;"><span>{{ org.childOrgId }}</span></td>
                  <td class="row-data">{{org.childOrgName}}</td>
                  <td class="row-data">{{ org.registeredOn | date:'dd-MMM-yyyy HH:mm:ss'}}</td>
                  <td class="row-data">{{ org.orgCreatedOn| date:'dd-MMM-yyyy HH:mm:ss' }}</td>
                  <td class="row-data">{{ org.status }}</td>
                  <td class="row-data">{{ org.comments }}</td>
                </tr>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</ng-template>
